<template lang="pug">
  .aside__subblock
    .aside__list
      .aside__item.lesson-aside-block.lesson-aside-card(@click="addBlock('1,1')")
        .lesson-aside-block__image
          Icon(icon="add-heading")
        p.lesson-aside-block__title
          | Заголовок
      .aside__item.lesson-aside-block.lesson-aside-card(@click="addBlock('1,2')")
        .lesson-aside-block__image
          Icon(icon="add-heading-with-option")
        p.lesson-aside-block__title
          | Заголовок с описанием

      .aside__item.lesson-aside-block.lesson-aside-card(@click="addBlock('1,4')")
        .lesson-aside-block__image
          Icon(icon="add-image")
        p.lesson-aside-block__title
          | Картинка

      .aside__item.lesson-aside-block.lesson-aside-card(@click="addBlock('1,3')")
        .lesson-aside-block__image
          Icon(icon="add-video")
        p.lesson-aside-block__title
          | Видео

      //- .aside__item.lesson-aside-block()
      //-   .lesson-aside-block__image
      //-     Icon(icon="add-audio")
      //-   p.lesson-aside-block__title
      //-     | Аудио

      .aside__item.lesson-aside-block.lesson-aside-card(@click="addBlock('1,6')")
        .lesson-aside-block__image
          Icon(icon="add-file")
        p.lesson-aside-block__title
          | Файл

      .aside__item.lesson-aside-block.lesson-aside-card(@click="addBlock('2,1')")
        .lesson-aside-block__image
          Icon(icon="add-task")
        p.lesson-aside-block__title
          | Задание

      .aside__item.lesson-aside-block.lesson-aside-card(@click="addBlock('1,7')")
        .lesson-aside-block__image
          Icon(icon="add-button")
        p.lesson-aside-block__title
          | Кнопка

      .aside__item.lesson-aside-block.lesson-aside-card(@click="addBlock('4,2')")
        .lesson-aside-block__image.-test-
          Icon(icon="add-test")
        p.lesson-aside-block__title
          | Тест

      .aside__item.lesson-aside-block.lesson-aside-card(@click="addBlock('5,2')")
        .lesson-aside-block__image.-test-
          Icon(icon="add-task")
        p.lesson-aside-block__title
          | Задание с правильным ответом

      //- .aside__item.lesson-aside-block()
      //-   .lesson-aside-block__image
      //-     Icon(icon="add-nps")
      //-   p.lesson-aside-block__title
      //-     | NPS


</template>

<script>
import File from '@/components/File/File';

import moment from 'moment';
import { mapState } from 'vuex';

export default {
  components: { File },
  data() {
    return {
      file: {
        fileName: 'file.txt',
        fileUrl: ''
      },
      blocksInitialData: {
        t1v1: {
          content: {
            header: 'Новый блок'
          },
          type: 1,
          variety: 1
        },
        t1v2: {
          content: {
            header: '',
            text: 'Описание'
          },
          type: 1,
          variety: 2
        },
        t1v3: {
          content: {
            videoUrl: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ',
            typeId: 1,
            img: {}
          },
          type: 1,
          variety: 3
        },
        t1v4: {
          content: {
            img: {
              id: 1,
              url: 'https://storage.yandexcloud.net/toolbox-lms/images/bbf9f8147cac293c286ce41813706867-5ed59f26bb721.jpeg',
              fileName: 'speed.jpeg'
            }
          },
          type: 1,
          variety: 4
        },
        t1v6: {
          content: {
            files: [],
            header: 'Заголовок файлов'
          },
          type: 1,
          variety: 6
        },
        t1v7: {
          content: {
            buttonText: 'Новая кнопка',
            buttonUrl: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ',
            isBlank: true,
            openInAppDefaultBrowser: false
          },
          type: 1,
          variety: 7
        },
        t2v1: {
          content: {
            questionArray: [
              {
                answer: {},
                question: {
                  isLinkForbidden: false,
                  isAutoCheck: false,
                  isReviewAfterDdl: false,
                  isFileAnswerAllow: true,
                  maxPoints: 10,
                  minPoints: 0,
                  textAfterDdl: '',
                  textBeforeDdl: '',
                  pointsAfterDdl: 0,
                  pointsBeforeDdl: 2,
                  question: 'Текст вопроса',
                  typeOfTask: 1,
                  variety: 1
                }
              }
            ],
            taskBlock: {
              ddl: moment().add(1, 'days').hours(26).minutes(59).seconds(59),
              systemName: 'Название задания'
            }
          },
          type: 2,
          variety: 1
        },
        t4v2: {
          type: 4,
          variety: 2,
          content: {
            preview: {
              title: 'Название теста',
              description: 'Описание теста',
              img: {}
            },
            results: [
              {
                isDeleted: false,
                pointsFrom: 0,
                pointsTo: 100,
                position: 0,
                text: 'Результат от 0 до 100',
                img: {}
              }
            ],
            questions: [
              {
                isDeleted: false,
                text: 'Вопрос 1',
                isMultipleAnswers: false,
                position: 1,
                img: {},
                answers: [
                  {
                    isDeleted: false,
                    text: 'Ответ 1',
                    isCorrect: true,
                    position: 0,
                    points: 0
                  }
                ]
              }
            ]
          }
        },
        t5v2: {
          type: 5,
          variety: 2,
          getIds: true,
          content: {
            title: 'Название задания',
            description: 'Описание задания',
            ddl: moment().add(1, 'days').hours(26).minutes(59).seconds(59),
            correctAnswers: '',
            pointsBeforeDdl: 2,
            pointsAfterDdl: 0,
            additionalCorrectAnswers: '',
            addCorAnsPointsBeforeDdl: 4,
            addCorAnsPointsAfterDdl: 0,
            answer: {}
          }
        },
        t6v2: {
          type: 6,
          variety: 2,
          getIds: true,
          content: {
            title: 'Название задания',
            description: 'Описание задания',
            answers: [],
            teamAndAnswers: []
          }
        }
      }
    };
  },
  computed: {
    ...mapState('coursesLesson', {
      parentBlock: s => s.aside.data.parent.block,
      partId: s => s.aside.data.parent.partId
    })
  },
  destroyed() {
    this.$store.dispatch('coursesLesson/setAsideData', {
      parent: {
        partId: '',
        block: {}
      }
    });
  },
  methods: {
    async addBlock(value) {
      const parseBlockSelected = value.split(',');
      const key = 't' + parseBlockSelected[0] + 'v' + parseBlockSelected[1];
      const newBlock = { ...this.blocksInitialData[key] };

      newBlock.prevBlock = {
        variety: this.parentBlock.variety,
        type: this.parentBlock.type,
        blockId: this.parentBlock.id
      };

      await this.$store.dispatch('coursesLesson/addBlock', {
        block: newBlock,
        partId: this.partId
      });
      await this.$store.dispatch('coursesLesson/setAsideMeta', {
        path: 'forceClose',
        value: true
      });
    }
  }
};
</script>
